import Vue from "vue"
import Router from "vue-router"
import { desktopRoutes } from "./desktop"
import { mobileRoutes } from "./mobile"
import store from "@/store"
import NProgress from "nprogress"
import "nprogress/nprogress.css"

NProgress.configure({ showSpinner: false })

const routes = store.state.app.isMobile ? mobileRoutes : desktopRoutes

Vue.use(Router)
const router = new Router({
  mode: "history",
  routes
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err
    }
  })
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  const isLogged = store.getters["auth/isLogged"]
  const publicPages = ["/login", "/register", "/password", "/demo", "/home"]
  const authRequired = !publicPages.includes(to.path)
  authRequired && !isLogged ? next("/login") : next()
})

router.afterEach(() => {
  NProgress.done()
})

router.onError(() => {
  NProgress.done()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js